
export default function VPNServices() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Advanced AES-256 encryption protects your data from unauthorized access and cyber threats.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to secure servers worldwide for optimal speed and unrestricted access to content.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your privacy is completely protected.'
    }
  ];

  return (
    <section id="vpn-services" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-widest text-blue-600 uppercase mb-5">
            OUR VPN SERVICE
          </p>
          <h2 className="text-6xl font-bold leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            <span className="text-[#1a2332]">PROTECTION THAT</span>
            <br />
            <span className="text-blue-600">WORKS FOR YOU</span>
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-3 gap-8 mt-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-200 rounded-3xl p-10 transition-all duration-300 hover:bg-blue-50/50 hover:shadow-xl hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex flex-col items-center text-center h-full">
                {/* Icon Area */}
                <div className="mb-8 flex items-center justify-center">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className={`${feature.icon} text-4xl text-white`}></i>
                  </div>
                </div>
                
                {/* Content */}
                <div className="flex-1 flex flex-col">
                  <h3 className="text-2xl font-semibold text-[#1a2332] mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {feature.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
